import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'
import './reporting.css'
import PropTypes from 'prop-types'
import { isEmptyString } from '../../../../helpers/sanityChecks'
import { CaptchaContainer } from '../../Captcha'

class Reporting extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        enableListeningKeyboardEvents: PropTypes.func.isRequired,
        disableListeningKeyboardEvents: PropTypes.func.isRequired,
        reportCollaborativeIndexation: PropTypes.func.isRequired,
        captcha: PropTypes.object.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.state = {
            isOpened: false,
            message: '',
            captcha: null,
        }

        this.toggleReporting = this.toggleReporting.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.closeReporting = this.closeReporting.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleCaptchaChange = this.handleCaptchaChange.bind(this)
    }

    toggleReporting()
    {
        this.setState({ isOpened: ! this.state.isOpened })
    }

    closeReporting()
    {
        this.setState({
            isOpened: false,
            message: '',
            captcha: null,
        })
    }

    handleSubmit()
    {
        const {
            addErrorAlert,
            t,
            captcha,
        } = this.props

        if(isEmptyString(this.state.message))
        {
            addErrorAlert(t('visualizer:toolbar.left.collaborativeIndexations.reporting.invalid'))

            return
        }

        if(captcha.isEnabled === true && this.state.captcha === null)
        {
            addErrorAlert(t('visualizer:captcha.invalid'))

            return
        }

        this.props.reportCollaborativeIndexation(this.state.message, this.state.captcha)
        this.closeReporting()
    }

    handleCaptchaChange(captcha)
    {
        this.setState({ captcha })
    }

    handleChange(event)
    {
        this.setState({ message: event.target.value })
    }

    render()
    {
        const {
            t,
            enableListeningKeyboardEvents,
            disableListeningKeyboardEvents,
            captcha,
        } = this.props
        const { isOpened } = this.state

        return (
            <div className={classNames('reporting-wrapper', {'opened': isOpened })}>
                <button
                    className={classNames('toggle-reporting', 'btn', 'tertiary', { 'active': isOpened === true })}
                    onClick={this.toggleReporting}
                    title={t('visualizer:toolbar.left.collaborativeIndexations.reporting.button.title')}
                >
                    <i className={'fa fa-bell fa-2x'} aria-hidden="true" />
                    <span className={'sr-only'}>{t('visualizer:toolbar.left.collaborativeIndexations.reporting.button.title')}</span>
                </button>
                { isOpened === true &&
                <div className={'reporting-form'}>
                    <div className={'preamble'}>
                        {t('visualizer:toolbar.left.collaborativeIndexations.reporting.preamble')}
                    </div>
                    <div className={'form-group'}>
                        <textarea
                            value={this.state.message}
                            onChange={this.handleChange}
                            onFocus={disableListeningKeyboardEvents}
                            onBlur={enableListeningKeyboardEvents}
                        />
                    </div>
                    { captcha.isEnabled === true && <CaptchaContainer onChange={this.handleCaptchaChange}/> }
                    <div className={'form-group'}>
                        <input
                            onClick={this.closeReporting}
                            type={"button"}
                            className={"btn secondary"}
                            value={t('visualizer:toolbar.left.collaborativeIndexations.reporting.cancel')}
                        />
                        <input
                            onClick={this.handleSubmit}
                            type={"button"}
                            className={"btn primary"}
                            value={t('visualizer:toolbar.left.collaborativeIndexations.reporting.valid')}
                        />
                    </div>
                </div>}
            </div>
        )
    }
}

export default withTranslation()(Reporting)
